import React from 'react';
//import './Login.css';
import { IonButton, IonContent, IonInput, IonPage, IonToast } from "@ionic/react"
import authStore from '../../store/auth';
import { observer } from "mobx-react";

const Login: React.FC = observer(() => {
    return (
        <IonPage>
            <IonContent fullscreen>
                <div style={{ 
                    backgroundColor: '#0984E3', 
                    minHeight: '100vh',
                    height: 'auto',
                    padding: '50px 25px 100px 25px'
                }}>
                    <div style={{ marginBottom: 50, marginTop: 100 }}>
                        <h1 style={{ margin: 0, color: 'white', fontWeight: 700, fontSize: 34, lineHeight: '34px', textAlign: 'center' }}>Sopipack Owner App</h1>
                        <p style={{ color: '#B8B8B8', textAlign: 'center' }}>Silahkan masuk ke akun anda</p>
                    </div>
                    <div style={{ marginBottom: 15 }}>
                        <IonInput 
                            style={{ backgroundColor: 'white', borderRadius: 8 }}
                            fill="outline" 
                            placeholder='Silahkan masukkan username'
                            value={authStore.username} 
                            onIonInput={(e: any) => authStore.username = e.target.value}
                        ></IonInput>
                        {/* <input 
                            value={authStore.email} 
                            onChange={(e) => authStore.email = e.target.value}
                            className='input-text' 
                            style={{ width: '100%' }} 
                            placeholder='Silahkan masukkan email' 
                        /> */}
                    </div>
                    <div style={{ marginBottom: 30 }}>
                        <IonInput 
                            style={{ backgroundColor: 'white', borderRadius: 8 }}
                            fill="outline" 
                            placeholder='Silahkan masukkan password'
                            value={authStore.password} 
                            onIonInput={(e: any) => authStore.password = e.target.value}
                            type='password'
                        ></IonInput>
                        {/* <input 
                            value={authStore.password} 
                            onChange={(e) => authStore.password = e.target.value}
                            className='input-text' 
                            style={{ width: '100%' }} 
                            placeholder='Silahkan masukkan password' 
                            type='password' 
                        /> */}
                    </div>
                    <div>
                        {/* <button className='gold-button' style={{ width: '100%' }} onClick={() => authStore.loginUser()}>Login Sekarang</button> */}
                        <IonButton expand='block' color='light' onClick={() => authStore.loginUser()}>Login</IonButton>
                    </div>
                </div>
                
                <IonToast
                    isOpen={authStore.success_alert_login_toggle}
                    message="Login Akun Berhasil!"
                    onDidDismiss={() => authStore.setSuccessAlertLoginToggle(false)}
                    duration={3000}
                    position='top'
                    color='success'
                ></IonToast>

                <IonToast
                    isOpen={authStore.failed_alert_login_toggle}
                    message="Login Akun Gagal!"
                    onDidDismiss={() => authStore.setFailedAlertLoginToggle(false)}
                    duration={3000}
                    position='top'
                    color='danger'
                ></IonToast>
            </IonContent>
        </IonPage>
    )
})

export default Login;